import React from 'react'
import { Link } from 'react-router-dom'
import './Aboutsalespartner.css'
import { FaMoneyBillAlt } from 'react-icons/fa'
import { IoMdBusiness } from 'react-icons/io'
import { HiCursorClick } from 'react-icons/hi'
import Header from './layouts/Header'
import Header5 from './components/Header5'
import { API_URL } from './config'

class Aboutsalespartner extends React.Component {
  componentDidMount() {
    document.title = 'Karamale - About Affiliate Program'
  }

  render() {
    const isPartner = localStorage.getItem('partnerid') !== null

    return (
      <div className="kx-affiliate">
        {isPartner ? <Header5 /> : <Header />}

        <main>
          <section className="kx-affiliate__hero">
            <div className="kx-affiliate__hero-pattern"></div>

            <div className="kx-affiliate__hero-inner">
              <div className="kx-affiliate__hero-copy">
                <div className="kx-affiliate__eyebrow">
                  <span></span>
                  KARAMALE AFFILIATE PROGRAM
                </div>

                <h1>
                  Turn your
                  <strong>network into income.</strong>
                </h1>

                <p>
                  Refer event organisers to Karamale, help them sell tickets and earn commission
                  from their activity on the platform.
                </p>

                <Link to="/affiliate-registration" className="kx-affiliate__hero-button">
                  Become an affiliate
                  <span>→</span>
                </Link>
              </div>

              <div className="kx-affiliate__hero-stat">
                <div className="kx-affiliate__hero-stat-top">
                  <span>YOUR POTENTIAL</span>
                  <span>01</span>
                </div>

                <strong>30%</strong>

                <p>
                  Earn up to 30% commission from the amount your recruits spend on Karamale to sell
                  tickets.
                </p>

                <div className="kx-affiliate__hero-stat-line"></div>

                <span className="kx-affiliate__hero-stat-bottom">
                  No limit on the number of recruits.
                </span>
              </div>
            </div>
          </section>

          <section className="kx-affiliate__intro">
            <div className="kx-affiliate__intro-label">
              <span>01</span>
              <p>THE PROGRAM</p>
            </div>

            <div className="kx-affiliate__intro-content">
              <h2>
                Your audience.
                <br />
                <strong>Your opportunity.</strong>
              </h2>

              <p className="kx-affiliate__intro-lead">
                Karamale's affiliate program allows influencers, bloggers, event professionals and
                members of the public to earn by referring event organisers to Karamale.
              </p>

              <p>
                Every affiliate receives a unique affiliate ID and referral tools. Use them to
                direct event organisers to Karamale. When those organisers use the platform to sell
                tickets, you can earn commission.
              </p>

              <p>
                Your dashboard gives you visibility into your recruits, their events, admission
                sales and payments due to you.
              </p>
            </div>
          </section>

          <section className="kx-affiliate__process">
            <div className="kx-affiliate__process-header">
              <div>
                <span className="kx-affiliate__section-number">02</span>
                <h2>
                  Three steps.
                  <br />
                  <strong>One opportunity.</strong>
                </h2>
              </div>

              <p>
                The process is simple. Sign up, bring event organisers onto Karamale and track your
                earnings from your dashboard.
              </p>
            </div>

            <div className="kx-affiliate__steps">
              <div className="kx-affiliate__step kx-affiliate__step--active">
                <div className="kx-affiliate__step-icon">
                  <HiCursorClick size={42} />
                </div>

                <span className="kx-affiliate__step-number">01</span>

                <h3>Sign up</h3>

                <p>
                  Register for the affiliate program and receive your unique affiliate ID and
                  referral tools.
                </p>
              </div>

              <div className="kx-affiliate__step">
                <div className="kx-affiliate__step-icon">
                  <IoMdBusiness size={42} />
                </div>

                <span className="kx-affiliate__step-number">02</span>

                <h3>Recruit</h3>

                <p>
                  Refer event organisers, event planners and event managers to Karamale. There is no
                  limit to how many clients you can recruit.
                </p>
              </div>

              <div className="kx-affiliate__step">
                <div className="kx-affiliate__step-icon">
                  <FaMoneyBillAlt size={42} />
                </div>

                <span className="kx-affiliate__step-number">03</span>

                <h3>Earn</h3>

                <p>
                  Earn up to 30% commission from the amount your recruits spend on Karamale to sell
                  tickets.
                </p>
              </div>
            </div>
          </section>

          <section className="kx-affiliate__dashboard">
            <div className="kx-affiliate__dashboard-header">
              <div>
                <span className="kx-affiliate__section-number">03</span>
                <h2>
                  Everything you need
                  <strong>in your dashboard.</strong>
                </h2>
              </div>

              <p>
                Your affiliate dashboard gives you the tools to understand your referrals, monitor
                activity and keep track of your earnings.
              </p>
            </div>

            <div className="kx-affiliate__dashboard-grid">
              <article className="kx-affiliate__dashboard-card kx-affiliate__dashboard-card--large">
                <div className="kx-affiliate__image-wrap">
                  <img
                    src={`${API_URL}/apps/kscanner/icons/affiliateid.jpeg`}
                    alt="Karamale affiliate ID"
                  />
                </div>

                <div className="kx-affiliate__dashboard-card-copy">
                  <span>01 / REFERRAL TOOL</span>
                  <h3>Affiliate ID</h3>
                  <p>
                    Share your unique affiliate ID or referral link with event organisers and
                    encourage them to sell tickets through Karamale.
                  </p>
                </div>
              </article>

              <article className="kx-affiliate__dashboard-card">
                <div className="kx-affiliate__image-wrap">
                  <img
                    src={`${API_URL}/apps/kscanner/icons/recruits.jpeg`}
                    alt="Karamale affiliate recruits"
                  />
                </div>

                <div className="kx-affiliate__dashboard-card-copy">
                  <span>02 / YOUR NETWORK</span>
                  <h3>Recruits</h3>
                  <p>
                    Your recruits are the Karamale clients you referred using your affiliate ID.
                    Keep track of the clients connected to you.
                  </p>
                </div>
              </article>

              <article className="kx-affiliate__dashboard-card">
                <div className="kx-affiliate__image-wrap">
                  <img
                    src={`${API_URL}/apps/kscanner/icons/payout.jpeg`}
                    alt="Karamale affiliate payout"
                  />
                </div>

                <div className="kx-affiliate__dashboard-card-copy">
                  <span>03 / YOUR EARNINGS</span>
                  <h3>Your wallet</h3>
                  <p>
                    Your wallet shows how much Karamale owes you. Your commission can increase as
                    your recruits generate activity.
                  </p>
                </div>
              </article>
            </div>
          </section>

          <section className="kx-affiliate__commission">
            <div className="kx-affiliate__commission-inner">
              <div className="kx-affiliate__commission-number">04</div>

              <div className="kx-affiliate__commission-copy">
                <span>THE MORE YOU BUILD</span>

                <h2>
                  Your network can
                  <strong>keep growing.</strong>
                </h2>

                <p>
                  There is no limit to the number of clients you can recruit. Every organiser you
                  bring to Karamale becomes part of your referral network.
                </p>
              </div>

              <div className="kx-affiliate__commission-stat">
                <strong>30%</strong>
                <span>up to commission</span>
              </div>
            </div>
          </section>

          <section className="kx-affiliate__faq">
            <div className="kx-affiliate__faq-title">
              <span className="kx-affiliate__section-number">05</span>

              <h2>
                Questions?
                <strong>We've got answers.</strong>
              </h2>
            </div>

            <div className="kx-affiliate__faq-list">
              <div className="kx-affiliate__faq-item">
                <span>01</span>

                <div>
                  <h3>How many clients can I recruit?</h3>
                  <p>
                    There is no limit to how many clients you can recruit for Karamale. The more
                    clients you bring onto the platform, the more opportunities you have to earn.
                  </p>
                </div>
              </div>

              <div className="kx-affiliate__faq-item">
                <span>02</span>

                <div>
                  <h3>Who can I recruit?</h3>
                  <p>
                    You can refer event planners, event organisers, event managers or anyone who
                    organises events and wants to sell tickets through Karamale.
                  </p>
                </div>
              </div>

              <div className="kx-affiliate__faq-item">
                <span>03</span>

                <div>
                  <h3>How do I track my referrals?</h3>
                  <p>
                    After signing up, you receive access to your dashboard and a unique referral
                    link. Clients who register through your link can appear in your recruit list
                    once they create an event.
                  </p>
                </div>
              </div>

              <div className="kx-affiliate__faq-item">
                <span>04</span>

                <div>
                  <h3>How do I know when a recruit creates an event?</h3>
                  <p>
                    Karamale can notify you by email when a client you've referred creates an event.
                  </p>
                </div>
              </div>

              <div className="kx-affiliate__faq-item">
                <span>05</span>

                <div>
                  <h3>How do I get paid?</h3>
                  <p>
                    During registration, you'll provide your banking details. Karamale uses those
                    details to process payments due to you, so it is important to make sure they are
                    accurate.
                  </p>
                </div>
              </div>

              <div className="kx-affiliate__faq-item">
                <span>06</span>

                <div>
                  <h3>When do recruits appear in my list?</h3>
                  <p>
                    A referred client may not appear in your recruit list immediately after signing
                    up. The client needs to create an event before the recruit becomes visible in
                    the relevant dashboard activity.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="kx-affiliate__privacy">
            <div>
              <span>06 / PRIVACY</span>
              <h2>Your information stays yours.</h2>
            </div>

            <p>
              Your banking details are used to process payments and are not shared with other
              companies for unrelated purposes.
            </p>
          </section>

          <section className="kx-affiliate__cta">
            <div className="kx-affiliate__cta-pattern"></div>

            <div className="kx-affiliate__cta-inner">
              <span>READY TO START?</span>

              <h2>
                Build your network.
                <strong>Earn from it.</strong>
              </h2>

              <p>Join the Karamale affiliate program and start referring event organisers today.</p>

              <Link to="/affiliate-registration" className="kx-affiliate__cta-button">
                Sign up as an affiliate
                <span>→</span>
              </Link>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

export default Aboutsalespartner
